export const DashboardIncidences = {
  title: 'Incidências'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/DashboardIncidences.js